import { NgSelectModule } from "@ng-select/ng-select";

import {
	AutofocusDirective,
	BpVoucherValueAccessor,
	CopyToClipboardDirective,
	PreventDefaultDirective
} from "./directives";

import { Angulartics2Module } from "angulartics2";
import { ToastrModule } from "ngx-toastr";
import { config } from "config/environment";
import { QRCodeModule } from "angularx-qrcode";
import { NgModule } from "@angular/core";
import { AngularModule } from "../angular.module";
import { ScrollToTopDirective } from "./directives/scroll-to-top.directive";
import { IndexHoldingsComponent } from "../main/components/index-holdings/index-holdings.component";
import { BpBoxComponent } from "./components/bp-box/bp-box.component";
import { NoChangePlaceholderComponent } from "../main/components/no-change-placeholder/no-change-placeholder.component";
import { BpDonutChartComponent } from "./components/bp-donut-chart/bp-donut-chart.component";
import { BpPriceLoadingComponent } from "./components/bp-price-loading/bp-price-loading.component";
import { BpBenefitListComponent } from "./components/bp-benefits-list/benefit-list.component";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ErrorInterceptorService } from "@core-services/error-interceptor.service";
import {
	BpListIconCssBpStyler,
	BpListItemComponent,
	BpListSubtitleCssBpStyler,
	BpListSubtitleSecondaryCssBpStyler,
	BpListTitleCssBpStyler,
	BpListTitleSecondaryCssBpStyler
} from "./components/bp-trading-list/bp-trading-list-item/bp-list-item.component";
import { BpListComponent } from "./components/bp-trading-list/bp-list.component";
import { ScrolledToBottomDirective } from "./directives/scrolled-to-bottom.directive";
import { LoadingButtonComponent } from "./components/loading-button/loading-button.component";
import { NotAvailableModalComponent } from "./components/not-available-modal/not-available-modal.component";
import { BpTileComponent } from "./components/bp-tile/bp-tile.component";
import { BpCollapsibleComponent } from "./components/bp-collapsible/bp-collapsible.component";
import { BpInfoBoxComponent } from "./components/bp-info-box/bp-info-box.component";
import { BpWarningBoxComponent } from "@modules/core/components/bp-error-chart-ui/bp-warning-box.component";
import { BpCollapsibleItemComponent } from "./components/bp-collapsible-item/bp-collapsible-item.component";
import { BpModalHeaderComponent } from "./components/bp-modal-header/bp-modalheader.component";
import { BpModalFrameComponent } from "./components/bp-modal-frame/bp-modal-frame.component";
import { BpContentComponent } from "./components/bp-content/bp-content.component";
import { WebcamQrModalComponent } from "./components/webcam-qr-modal/webcam-qr-modal.component";
import { BpInfoComponent } from "./components/bp-info/bp-info.component";
import { BpContentLoadIndicatorComponent } from "./components/bp-content-placeholder/bp-content-load-indicator.component";
import { BpSegmentButtonComponent } from "./components/bp-segment-button/bp-segment-button.component";
import { BpSelectorFrequencyComponent } from "./components/bp-selector-frequency/bp-selector-frequency.component";
import { BpSliderComponent } from "./components/bp-slider/bp-slider.component";
import { BpSvgIconComponent } from "./components/bp-svg-icon/bp-svg-icon.component";
import { BpInputPhoneComponent } from "./components/bp-input-phone/bp-input-phone.component";
import { ConfirmModalComponent } from "./components/confirm-modal/confirm-modal.component";
import { ModalCollectionComponent } from "./components/modal-collection/modal-collection.component";
import { LoadingSpinnerComponent } from "./components/loading-spinner/loading-spinner.component";
import { PaginationComponent } from "./components/pagination/pagination.component";
import { BpErrorBoxComponent } from "./components/bp-error-box/bp-error-box.component";
import { BpSelectComponent } from "./components/bp-select/bp-select.component";
import { AssetIconPipe } from "./pipes/asset-icon.pipe";
import { SignChangerDirective } from "@modules/core/directives/sign-changer.directive";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { BpSwitchModule } from "@modules/core/components/bp-switch/bp-switch.module";
import { BpInputNumberLeadingTrailingDot } from "@modules/core/directives/bp-input-number-leading-trailing-dot";
import { FeatureVisibilityDirective } from "@modules/core/directives/feature-visibility.directive";
import { NumbersOnlyDirective } from "@helpers/numbers-only.directive";
import { LimitDecimalToCurrencyDirective } from "@helpers/limit-decimal-to-currency.directive";
import { DateFormatPipe } from "@modules/core/pipes/date-format.pipe";
import { provideLottieOptions } from "ngx-lottie";
import player from "lottie-web";
import { BpArrowNavigationDirective } from "./directives/bp-arrow-navigation.directive";
import { EngageAccessibleElementDirective } from "./directives/engage-accessible-element";
import { ElementIsIntoViewDirective } from "./directives/element-is-into-view.directive";
import { BpSearchBarComponent } from "@modules/core/components/bp-search-bar/bp-search-bar.component";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { BpSegmentMobileButtonComponent } from "@modules/core/components/bp-segment-mobile-button/bp-segment-mobile-button.component";
import { TimeFrameFilterComponent } from "@modules/core/components/bp-segment-mobile-button/time-frame-filter/time-frame-filter.component";
import { BpMobileSelectOptionsComponent } from "@modules/core/components/bp-mobile-select/bp-mobile-select-options/bp-mobile-select-options.component";
import { BpMobileSelectComponent } from "@modules/core/components/bp-mobile-select/bp-mobile-select.component";
import { BpTypeDirective } from "@modules/core/directives/bp-type.directive";
import { BpInputComponent } from "@modules/core/components/bp-input/bp-input.component";
import { BpTooltipDirective } from "@modules/core/directives/bp-tooltip/bp-tooltip.directive";
import { GlobalInterceptorService } from "@modules/+new/core/interceptors/global-interceptor.service";
import { BpFilesUploadComponent } from "@modules/core/components/bp-files-upload/bp-files-upload.components";
import { PofFacade } from "@modules/pof/domain/+state/pof.facade";
import { BpTruncateTextComponent } from "@modules/core/components/bp-truncate-text-middle/bp-truncate-text-middle.components";
import { ScrollToHere } from "@modules/core/directives/automatically-scroll-to-bottom.directive";
import { BpGlobalNotificationsComponent } from "@modules/shared/bp-global-notifications/bp-global-notifications.component";
import { ComponentsAngularModule } from "@bitpanda-design-system/angular";
import { BpProfilePictureComponent } from "@modules/core/components/bp-profile-picture/bp-profile-picture.component";
import { HideOnBreakpointDirective } from "@modules/core/directives/breakpoint.directive";
import { BpProgressIndicatorComponent } from "@modules/core/components/bp-progress-indicator/bp-progress-indicator.component";
import { CountdownSpinnerComponent } from "@modules/core/components/countdown-spinner/countdown-spinner.component";
import { HidePortfolioDirective } from "@modules/shared/components/hide-portfolio-value/hide-portfolio-value.directive";
import { HidePortfolioValueComponent } from "@modules/shared/components/hide-portfolio-value/hide-portfolio-value.component";
import { BpExtendedTooltipComponent } from "./components/bp-extended-tooltip/bp-extended-tooltip.component";
import { BpExtendedTooltipDirective } from "./components/bp-extended-tooltip/bp-extended-tooltip.directive";
import { StripDotsAndCommasDirectives } from "@helpers/strip-commas-and-dots";
import { PipeModule } from "@modules/core/pipes/pipe.module";
import { SvgInlineComponent } from "@modules/shared/svg-inline/svg-inline.component";

const directives = [
	CopyToClipboardDirective,
	PreventDefaultDirective,
	ScrollToTopDirective,
	ScrolledToBottomDirective,
	BpListIconCssBpStyler,
	BpListTitleCssBpStyler,
	BpListSubtitleCssBpStyler,
	BpListTitleSecondaryCssBpStyler,
	BpListSubtitleSecondaryCssBpStyler,
	SignChangerDirective,
	BpInputNumberLeadingTrailingDot,
	BpArrowNavigationDirective,
	SignChangerDirective,
	FeatureVisibilityDirective,
	NumbersOnlyDirective,
	LimitDecimalToCurrencyDirective,
	EngageAccessibleElementDirective,
	ElementIsIntoViewDirective,
	BpTypeDirective,
	BpTooltipDirective,
	AutofocusDirective,
	ScrollToHere,
	HideOnBreakpointDirective,
	HidePortfolioDirective,
	StripDotsAndCommasDirectives
];

@NgModule({
	declarations: [
		...directives,
		BpInputPhoneComponent,
		BpSegmentButtonComponent,
		BpSegmentMobileButtonComponent,
		PaginationComponent,
		LoadingButtonComponent,
		ModalCollectionComponent,
		ConfirmModalComponent,
		NotAvailableModalComponent,
		WebcamQrModalComponent,
		BpTileComponent,
		IndexHoldingsComponent,
		BpInfoComponent,
		BpVoucherValueAccessor,
		BpModalHeaderComponent,
		BpContentComponent,
		BpModalFrameComponent,
		BpSliderComponent,
		BpSelectComponent,
		BpSelectorFrequencyComponent,
		BpCollapsibleComponent,
		BpCollapsibleItemComponent,
		BpSvgIconComponent,
		BpContentLoadIndicatorComponent,
		BpBoxComponent,
		NoChangePlaceholderComponent,
		BpBenefitListComponent,
		BpDonutChartComponent,
		BpInfoBoxComponent,
		BpWarningBoxComponent,
		BpErrorBoxComponent,
		BpPriceLoadingComponent,
		LoadingSpinnerComponent,
		BpListComponent,
		BpListItemComponent,
		AssetIconPipe,
		DateFormatPipe,
		BpSearchBarComponent,
		TimeFrameFilterComponent,
		BpMobileSelectComponent,
		BpMobileSelectOptionsComponent,
		BpInputComponent,
		BpFilesUploadComponent,
		BpTruncateTextComponent,
		BpProfilePictureComponent,
		BpGlobalNotificationsComponent,
		BpProgressIndicatorComponent,
		CountdownSpinnerComponent,
		HidePortfolioValueComponent,
		BpExtendedTooltipComponent,
		BpExtendedTooltipDirective
	],
	imports: [
		AngularModule,
		NgSelectModule,
		// Angulartics2Module.forRoot([Angulartics2GoogleAnalytics], { developerMode: false}),
		Angulartics2Module.forRoot({ developerMode: config.debug }),
		ToastrModule.forRoot(),
		QRCodeModule,
		TranslationPipeModule,
		BpSwitchModule,
		MatBottomSheetModule,
		ComponentsAngularModule,
		SvgInlineComponent,
		PipeModule
	],
	exports: [
		...directives,
		AngularModule,
		BpInputPhoneComponent,
		BpSegmentButtonComponent,
		BpSegmentMobileButtonComponent,
		PaginationComponent,
		LoadingButtonComponent,
		ModalCollectionComponent,
		ConfirmModalComponent,
		NotAvailableModalComponent,
		WebcamQrModalComponent,
		NgSelectModule,
		Angulartics2Module,
		ToastrModule,
		QRCodeModule,
		BpTileComponent,
		BpInfoComponent,
		BpVoucherValueAccessor,
		IndexHoldingsComponent,
		BpModalHeaderComponent,
		BpContentComponent,
		BpSliderComponent,
		BpSelectComponent,
		BpSelectorFrequencyComponent,
		BpContentLoadIndicatorComponent,
		BpCollapsibleComponent,
		BpCollapsibleItemComponent,
		BpSvgIconComponent,
		BpBoxComponent,
		NoChangePlaceholderComponent,
		BpBenefitListComponent,
		BpDonutChartComponent,
		BpInfoBoxComponent,
		BpWarningBoxComponent,
		BpErrorBoxComponent,
		BpPriceLoadingComponent,
		LoadingSpinnerComponent,
		BpListItemComponent,
		BpListComponent,
		AssetIconPipe,
		DateFormatPipe,
		TranslationPipeModule,
		BpSwitchModule,
		BpSearchBarComponent,
		TimeFrameFilterComponent,
		BpMobileSelectComponent,
		BpMobileSelectOptionsComponent,
		BpInputComponent,
		BpFilesUploadComponent,
		BpTruncateTextComponent,
		ComponentsAngularModule,
		BpProfilePictureComponent,
		BpProgressIndicatorComponent,
		CountdownSpinnerComponent,
		HidePortfolioValueComponent,
		BpExtendedTooltipComponent,
		BpExtendedTooltipDirective,
		PipeModule,
		SvgInlineComponent
	],
	providers: [
		provideLottieOptions({
			player: () => player
		}),
		PofFacade,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: GlobalInterceptorService,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptorService,
			multi: true
		}
	]
})
export class CoreModule {}
